// Helper functions to standardize Timeline analytics tracking
// All functions hide boilerplate such as suppressing property inheritance
// and common Timeline-specific payload fields.

import { AnalyticsEvent } from '@/analytics/schema/events.schema'
import { getTrackEventGlobal } from '@/analytics/utils/analytics-helpers'
import type { TrackEventFn } from '@/analytics/hooks/useAnalytics'

/**
 * Track a Timeline specific analytics event.
 * Automatically applies { suppressFeatureInheritance: true } so that no
 * residual properties from previous events leak into this payload.
 */
export function trackTimelineEvent(
  event: AnalyticsEvent,
  props: Record<string, string | number | boolean>,
  track: TrackEventFn | undefined = getTrackEventGlobal()
) {
  if (!track) return
  track(event, props, {
    suppressFeatureInheritance: true,
  })
}
